/**
 * One quiet line per history-persistence decision, so a run whose answer never reached the server can be
 * explained from the browser console: a turn that finished, which guard (if any) refused to mirror it,
 * and how an attempted mirror ended. No message content, only the thread id, a stable reason code and
 * small facts. It changes no decision: every guard that refused before still refuses.
 */
export type HistoryReason =
  | 'finish' // the SDK's onFinish fired (detail carries the abort/disconnect/error flags)
  | 'passive_follower'
  | 'signed_out'
  | 'owner_changed' // the captured current-owner guard is false (session boundary moved)
  | 'owner_changed_after_thread_upsert'
  | 'aborted'
  | 'disconnected'
  | 'errored'
  | 'not_assistant'
  | 'thread_upsert_failed' // POST /api/v1/threads answered not-ok
  | 'message_post_failed' // POST /api/v1/threads/:id/messages answered not-ok
  | 'mirror_error' // the request threw (network error, timeout abort)
  | 'mirror_retry' // a timeout, network error or transient status; the same idempotent write is sent again
  | 'thread_deleted'
  | 'mirrored'; // the answer reached the server

export function traceHistory(
  threadId: string,
  reason: HistoryReason,
  detail: Record<string, string | number | boolean | null> = {},
): void {
  try {
    console.info(`[poneva-history] ${reason}`, { threadId, ...detail });
  } catch {
    /* tracing never affects persistence */
  }
}
